module.exports = __webpack_public_path__ + "static/media/errorImage.58c4b164.jpg";